// @ts-nocheck
import { getStoriesAlgolia } from '../../lib/graphql/getStoriesAlgolia';
import { getPressReleaseAlgolia } from '../../lib/graphql/getPressReleaseAloglia';
import { getMediaLibraryItemsAlgolia } from '../../lib/graphql/getMediaLibraryItemsAlgolia';
import { NextApiRequest, NextApiResponse } from 'next';
import { verifyWebhookSignature } from '@hygraph/utils';
import algoliasearch from 'algoliasearch';
const algolia = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APP_ID,
  process.env.ALGOLIA_ADMIN_API_KEY,
  {
    timeouts: {
      connect: 10, // (Custom) connect timeout in seconds
      read: 5, // (Default) read timeout in seconds
      write: 30, // (Default) write timeout in seconds
    },
  },
);
export const SEARCH_INDEX_SORTED = 'corp_search_date_timestamp';

const secret = process.env.HYGRAPH_WEBHOOK_SECRET;

const algoliaIndexPrefix = 'corp';
export const algoliaPrefixes = ['Stories', 'PressReleases', 'MediaLibrary', 'Search'].reduce(
  (acc: any, indexName: string) => ({
    ...acc,
    [indexName]: `${algoliaIndexPrefix}_${indexName.toLowerCase()}`,
  }),
  {},
);

export const facetsKeys = {
  //'Search': ['type', 'title', 'date', 'markets', 'locale_market' , 'filterOnly(locale)'],
  Stories: ['storyTagEnum', 'year', 'markets', 'filterOnly(locale)'],
  MediaLibrary: ['mediaCategory', 'mediaType', 'market', 'filterOnly(locale)'],
  PressReleases: ['topicEnum', 'year', 'market', 'market_locale', 'filterOnly(locale)'],
};

// unfortunately we cannot use algolia for corp site search because we cannot create filters like (A OR B) OR B
// leave this in commented in case it will work in the future.

// export const TAlgoliaSearchTypes = {
//   'STORY': 'STORY',
//   'PRESSRELEASE':'PRESSRELEASE'
// }

// export type TAlgoliaReturnValue = {
//   objectID: string;
//   title: string;
//   slug: string;
//   date: string;
//   locale: string;
//   locale_market: string;
//   markets: string[];
//   type: TAlgoliaSearchTypes
// }

// // this updates the corp search index used for page search
// const updateSearchIndex = async (itemType:TAlgoliaSearchTypes, items:any[])=>{

//   const searchResults: TAlgoliaReturnValue[] = items.map((item: any) => {

//     // press releases can have localized content in `default` locale, german for example
//     const localeForMarket = itemType === TAlgoliaSearchTypes.PRESSRELEASE ? item.market : item.locale;

//     let locale = null;
//     let market = null;
//     if(itemType === TAlgoliaSearchTypes.PRESSRELEASE) {
//       if(item.market === 'global') {
//         // locales are correct
//         locale = item.locale;
//       } else {
//         // locales are not correct, maybe german content in "default"
//         locale = item.market;
//       }
//     } else {

//     }
//     const ret:TAlgoliaReturnValue = {
//       objectID: `${itemType}_${item.id}_${item.locale}`,
//       title: item.title,
//       slug: item.slug,
//       date: item.date,
//       locale_market: itemType === TAlgoliaSearchTypes.PRESSRELEASE ? `${item.market}_${item.locale}` : '',
//       markets: item.markets ? item.markets : [item.market], // press releases have only 1 market
//       [SEARCH_INDEX_SORTED]: Math.floor(new Date(item.date).getTime() / 1000),
//       locale: item.locale,
//       type: itemType
//     };

//     return ret;
//   });
//   const searchIndex = algolia.initIndex(algoliaPrefixes['Search']);
//   searchIndex.setSettings({
//       attributesForFaceting: facetsKeys['Search'],
//       replicas: [
//         // configure virtual replica for sorting by date
//         // More info: https://www.algolia.com/doc/guides/managing-results/refine-results/sorting/how-to/sort-an-index-by-date/?client=javascript
//         `virtual(${SEARCH_INDEX_SORTED})`
//       ],
//   });

//   try {
//     await searchIndex.partialUpdateObjects(searchResults, {
//       createIfNotExists: true,
//     }).then(({ objectIDs }) => {
//       console.log('Updated corp search items on algolia with IDs:', objectIDs);
//     })
//   } catch(e) {
//     console.error('Error on updating the corp search index on algolia!', e);
//   }
//   return searchResults;
// }

const webhook = async (req: NextApiRequest, res: NextApiResponse) => {
  const body = req.body;
  const signature = req.headers['gcms-signature'];
  const isValid = verifyWebhookSignature({ body, signature, secret });

  if (
    (!(req.method === 'POST' && req.body?.operation === 'publish') ||
      !(req.method === 'GET' && req.query?.type)) &&
    !isValid
  ) {
    const debug = {
      signature,
      headers: req.headers,
      isValid,
    };
    return res.status(401).send(debug);
  }

  // console.log('req', req.method, req.body.data.localizations[0].title, req.body);
  const reqType = req.body?.data?.__typename || req.query?.type;
  let index, queryResults;

  switch (reqType) {
    case 'Story':
      queryResults = await getStoriesAlgolia([]);
      queryResults = queryResults.map((story: any) => {
        // default to `sustainability` when i.e. `sustainability_food`
        if (story.storyTagEnum && story.storyTagEnum.search(/sustainability/i) !== -1) {
          story.storyTagEnum = 'sustainability';
        }
        return story;
      });
      index = algolia.initIndex(algoliaPrefixes['Stories']);
      index.setSettings({
        attributesForFaceting: facetsKeys['Stories'],
      });
      // await updateSearchIndex(TAlgoliaSearchTypes.STORY, queryResults);
      break;
    case 'PressRelease':
      queryResults = await getPressReleaseAlgolia([]);
      index = algolia.initIndex(algoliaPrefixes['PressReleases']);
      index.setSettings({
        attributesForFaceting: facetsKeys['PressReleases'],
      });
      // await updateSearchIndex(TAlgoliaSearchTypes.PRESSRELEASE, queryResults);
      break;
    case 'MediaLibraryItem':
      queryResults = await getMediaLibraryItemsAlgolia([]);
      index = algolia.initIndex(algoliaPrefixes['MediaLibrary']);
      index.setSettings({
        attributesForFaceting: facetsKeys['MediaLibrary'],
      });
      break;
    default:
      return res.status(400).end();
  }
  const items = queryResults.map((item) => {
    const results = {
      objectID: `${item.id}_${item.slug}_${item.locale}`,
      market_locale: `${item.market}_${item.locale}`,
      ...item,
    };
    if (item.date) {
      results.year = new Date(item.date).getFullYear();
      results.date_timestamp = new Date(item.date).getTime();
      index.setSettings(
        {
          ranking: [
            'desc(date_timestamp)',
            'typo',
            'geo',
            'words',
            'filters',
            'proximity',
            'attribute',
            'exact',
            'custom',
          ],
        },
        {
          forwardToReplicas: true,
        },
      );
    }
    return results;
  });

  await index.clearObjects();
  await index.saveObjects(items);

  // return data to graphcms for easier debugging
  const respData = {
    typeName: req.body?.data?.__typename,
    itemCount: items && items.length > 0 ? items.length : -1,
    firstItemId: items[0]?.id,
    lastItemId: items[items.length - 1]?.id,
  };

  return res.send(respData);
};
export default webhook;
